export const IP = "ciboqa.cibovita.com:4000";
